import { Button, Tabs } from "@mantine/core";
import React from "react";
import { FaFilter, FaSearch } from "react-icons/fa";

const traders = [
  {
    name: "27直走",
    stats: {
      pnl: "+492,796.50",
      roi: "+681.44%",
      aum: "1,144,773.13",
      mdd: "85.66%",
      sharpe: "6.19",
    },
    chart: true,
    isFull: true,
  },
  {
    name: "叫我老徐",
    stats: {
      pnl: "+373,369.51",
      roi: "+13,463.84%",
      aum: "492,547.02",
      mdd: "100.00%",
      sharpe: "-1.16",
    },
    chart: true,
    isFull: true,
  },
  {
    name: "xiaomubiao001",
    stats: {
      pnl: "+333,319.20",
      roi: "+50.12%",
      aum: "2,174,806.03",
      mdd: "2.22%",
      sharpe: "--",
    },
    chart: true,
    isFull: false,
  },
];

const Futures = () => {
  return (
    <div className="p-6 space-y-6">
      {/* Top Banner */}
      <div className="bg-yellow-100 text-sm text-black rounded px-4 py-3 flex justify-between items-center">
        <span>
          Be a Futures Lead Trader, enjoy up to 30% profit share + 10%
          commission rebate!
        </span>
        <button className="bg-yellow-300 hover:bg-yellow-400 text-black px-3 py-1 rounded">
          Apply Now
        </button>
      </div>

      {/* Balance Section */}
      <div className="flex justify-between items-center">
        <div>
          <p className="text-gray-500 text-sm">Total Margin Balance</p>
          <p className="text-2xl font-semibold">
            0.00 <span className="text-sm">USDT</span>
          </p>
          <p className="text-gray-400 text-sm">Total Unrealized PnL --</p>
          <button className="mt-2 bg-yellow-300 hover:bg-yellow-400 text-black text-sm px-4 py-2 rounded">
            Copy Overview
          </button>
        </div>
        <div className="text-center border rounded px-4 py-6">
          <h2 className="font-semibold text-lg">How to Lead Trades?</h2>
          {/* Placeholder Icon */}
          <div className="mt-2 text-yellow-500">👨‍💼➕</div>
        </div>
      </div>

      {/* Filter Bar */}
      {/* <div className="flex justify-between items-center border-b pb-2">
        <div className="space-x-4">
          <button className="font-medium border-b-2 border-yellow-400 pb-1">All Portfolios</button>
          <button className="text-gray-400">My Favorites</button>
        </div>
      </div> */}

      <Tabs defaultValue="AllPortfolios">
        <Tabs.List>
          <Tabs.Tab value="AllPortfolios">All Portfolios</Tabs.Tab>
          <Tabs.Tab value="MyFavorites">My Favorites</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="AllPortfolios">
          <div className="flex justify-between my-6">
            <div className="flex items-center gap-2">
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>30 Days</option>
              </select>
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>PnL</option>
              </select>
              <label className="text-sm flex items-center space-x-1">
                <input type="checkbox" className="mr-1" defaultChecked />
                Smart Filter
              </label>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center border rounded-lg px-3 py-2 w-60">
                <FaSearch className="text-gray-400 mr-2" />
                <input
                  type="text"
                  placeholder="Trader's Name"
                  className="outline-none text-sm w-full bg-transparent"
                />
              </div>

              <button className="p-2 rounded-md">
                <FaFilter className="" />
              </button>

              <button className="bg-gray-800 text-white text-xs font-semibold px-2 py-1 rounded">
                VS
              </button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {traders.map((trader, index) => (
              <div key={index} className="border rounded p-4 space-y-3">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2 font-semibold">
                    {trader.name}
                  </div>
                  <span className="text-xs text-gray-400">Mock</span>
                </div>
                <div>
                  <p className="text-sm text-gray-500">30 Days PNL</p>
                  <p className="text-green-500 text-xl font-bold">
                    {trader.stats.pnl}
                  </p>
                  <p className="text-xs text-green-400">
                    ROI {trader.stats.roi}
                  </p>
                </div>

                <div className="grid grid-cols-3 text-xs text-gray-500 mt-2">
                  <div>
                    <p>AUM</p>
                    <p className="font-medium">{trader.stats.aum}</p>
                  </div>
                  <div>
                    <p>30 Days MDD</p>
                    <p className="font-medium">{trader.stats.mdd}</p>
                  </div>
                  <div>
                    <p>Sharpe Ratio</p>
                    <p className="font-medium">{trader.stats.sharpe}</p>
                  </div>
                </div>

                <div className="flex justify-between items-center">
                  <button className="bg-yellow-300 hover:bg-yellow-400 py-2 px-4 mr-4 rounded-lg">
                    Mock
                  </button>
                  <button
                    className={`w-full py-2 rounded text-sm font-medium ${
                      trader.isFull
                        ? "bg-red-100 text-red-600 cursor-not-allowed"
                        : "bg-yellow-300 hover:bg-yellow-400 text-black"
                    }`}
                  >
                    {trader.isFull ? "Full" : "Copy"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Tabs.Panel>
        <Tabs.Panel value="MyFavorites">
          <div className="w-full flex justify-center items-center py-16">
            <h3>No portfolios found</h3>
          </div>
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default Futures;
